import { useState } from "react";
import styled from "styled-components";

interface IProps {
    headText: string;
    createdAt: string;
    descriptionText: string;
    themeColor: string;
    onClick: () => void;
}

export const Readmore = (props: IProps) => {
    const [isClicked, setIsClicked] = useState(false);

    const handleClickRead = () => {
        setIsClicked(!isClicked);
        props.onClick();
    };

    return (
        <StyledContentPopupNews themeColor={props.themeColor}>
            <h2>{props.headText}</h2>
            <div className="datetime-popup-news">
                {props.createdAt}
            </div>
            <p
                className={isClicked ? "clicked" : ""}
                dangerouslySetInnerHTML={{
                    __html: props.descriptionText,
                }}
            ></p>
            <div className="readmore" onClick={handleClickRead}>
                Read more
            </div>
        </StyledContentPopupNews>
    );
};

const StyledContentPopupNews = styled.div<{ themeColor: string }>`
            position: absolute;
            left: 0;
            bottom: 0;
            padding: 32px 16px;
            h2 {
                font-size: 20px;
                line-height: 23px;
                margin-bottom: 8px;
                font-weight: 600;
                color: #fff;
            }
            .datetime-popup-news {
                background-image: url(../../images/ic-datetime.svg);
                background-position: left center;
                background-repeat: no-repeat;
                background-size: 10px;
                font-size: 10px;
                line-height: 13px;
                color: #c9c5bc;
                margin-bottom: 8px;
                padding-left: 16px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #fff;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: inherit;
                overflow: hidden;
                p:last-child {
                    -webkit-line-clamp: 3;
                }
            }
            p.clicked {
                p:last-child {
                    -webkit-line-clamp: initial;
                }
            }
            .readmore {
                font-weight: 600;
                color: ${(p) => p.themeColor};
            }
`;